module.exports = __webpack_public_path__ + "img/delbtn.263a452e.svg";